// extracted by mini-css-extract-plugin
module.exports = {"timelineStructureParent":"Timeline-module--timelineStructureParent--2fCmi"};